export default "__VITE_ASSET__44ddd00c__"